module.exports = __webpack_public_path__ + "preview_background.fa97fb2.jpg";